export default "__VITE_ASSET__98a8a22a__"